'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createDecoratedClass = (function () { function defineProperties(target, descriptors, initializers) { for (var i = 0; i < descriptors.length; i++) { var descriptor = descriptors[i]; var decorators = descriptor.decorators; var key = descriptor.key; delete descriptor.key; delete descriptor.decorators; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor || descriptor.initializer) descriptor.writable = true; if (decorators) { for (var f = 0; f < decorators.length; f++) { var decorator = decorators[f]; if (typeof decorator === 'function') { descriptor = decorator(target, key, descriptor) || descriptor; } else { throw new TypeError('The decorator for method ' + descriptor.key + ' is of the invalid type ' + typeof decorator); } } if (descriptor.initializer !== undefined) { initializers[key] = descriptor; continue; } } Object.defineProperty(target, key, descriptor); } } return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) { if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers); if (staticProps) defineProperties(Constructor, staticProps, staticInitializers); return Constructor; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _assert = require('./assert');

var _assert2 = _interopRequireDefault(_assert);

var _injector = require('./injector');

var _injector2 = _interopRequireDefault(_injector);

var _transaction = require('./transaction');

var _transaction2 = _interopRequireDefault(_transaction);

var _session = require('./session');

var _session2 = _interopRequireDefault(_session);

var _emitter = require('./emitter');

var _emitter2 = _interopRequireDefault(_emitter);

var _cacheKey = require('./cache-key');

var _cacheKey2 = _interopRequireDefault(_cacheKey);

var QueryIndex = new Map();

/******************************************************************************
 * The Query is our main point of interaction when writing code. Since we
 * need to run different queries on server & browser we use dependency
 * injection to define and invoke queris.
 *
 * Definition:
 *
 *    To define a query simply provide a name and a function to execute
 * 	  to the query static Query.define() method. To invoke a query elsewhere
 * 	  you can simply call the Query.run() method with the same name and
 * 	  any number of arguments. This is the mechanism by which we perfrom
 * 	  depnednecy injection of queries. 
 *
 * Transactions
 *
 * 	  The run method of a query returns a Transaction instance. This
 * 	  instance can either be run through a session, which is the case when
 * 	  we render react, or session-less to avoid any caching, which is the
 * 	  case when invoked through our rest api.
 *
 * 	  A transaction is modeled to be similar to a promise so you can
 * 	  then/catch it, but it also contains the methods to resolve/reject.
 *
 * Injection
 *
 * 	  Ideally we do not want to manage the lifecycle of a query and instead
 * 	  simply want to ensure that a query gets defined as a property on 
 * 	  once of our components. For this we can use the inject() method to
 * 	  decorate a class. The inject method will create a higher order
 * 	  component that will wrap our original one and will handle query
 * 	  transactions. The results of an injection are passed as props to
 * 	  the original component.
 *
 * Standalone
 *
 *    Queries can also be run standalone without the injection mechanism.
 *    This can be useful for a number of reasons, for example if you wish
 *    to circumvent the session caching, you can run the query within a
 *    clean session context. Alternatively if its data that does not need
 *    to be fetched on server, maybe you want to speed loading time up by
 *    fetching partial data on the server and then load the rest from 
 *    the client so you can show the page a bit faster.
 *
 *    The standard way of running queries is really the same as the
 *    in the injector example except that you must handle the transaction
 *    lifecycle yourself.
 *
 *    Example:
 *
 *       class MyComponent extends React.Component {
 *           constructor (...args) {
 *               super(...args);
 *               this.state = {
 *                   otherData : null
 *               };
 *           }
 *           //...
 *           componentDidMount () {
 *               // this is where you would run the query. it is up to
 *               // you to save a reference to a query somewhere and
 *               // unobserve if the component unmounts before the query
 *               // transaction gets resolved.
 *               let tx = Query
 *                    .run('GetOtherData')
 *                    .observe(result => {
 *                        if (tx.error) {
 *                            console.error(result);
 *                        } else {
 *                            this.setState({otherData: result});
 *                        }
 *                    });
 *           }
 *           //...
 *           render () {
 *               return (<div>
 *                   <OtherComponent data={this.state.otherData} />
 *               </div>)
 *           }
 *       }
 */

var Query = (function () {
	_createClass(Query, null, [{
		key: 'inject',
		value: function inject(method) {
			return function (Component) {
				return (0, _injector2['default'])(Component, method);
			};
		}
	}, {
		key: 'define',
		value: function define(name, execute) {
			var q = new Query(name, execute);
			QueryIndex.set(name, q);
			return q.run;
		}
	}, {
		key: 'run',
		value: function run(name) {
			// console.log('[reactr] Query.run('+ name +')', args);
			var query = QueryIndex.get(name);
			if (query instanceof Query) {
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}

				return query.run.apply(query, args);
			}
			throw new Error('Unknown query ' + name);
		}
	}, {
		key: 'defer',
		value: function defer(name) {
			// console.log('[reactr] Query.defer('+ name +')', args);
			var query = QueryIndex.get(name);
			if (query instanceof Query) {
				for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
					args[_key2 - 1] = arguments[_key2];
				}

				return query.defer.apply(query, args);
			}
			throw new Error('Unknown query ' + name);
		}
	}, {
		key: 'Begin',
		value: 'query:begin',
		enumerable: true
	}, {
		key: 'End',
		value: 'query:end',
		enumerable: true
	}, {
		key: 'Error',
		value: 'query:error',
		enumerable: true
	}]);

	function Query(name) {
		var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		_classCallCheck(this, Query);

		if (typeof options === 'function') {
			options = {
				execute: options
			};
		}

		(0, _assert2['default'])(typeof name === 'string', 'Not a valid name: ' + name);
		(0, _assert2['default'])(typeof options.execute === 'function', 'Missing execute function');

		this.name = name;
		this.options = options;
		this.execute = options.execute;
	}

	_createDecoratedClass(Query, [{
		key: 'getUniqueKey',
		value: function getUniqueKey() {
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}

			return _cacheKey2['default'].apply(undefined, [this.name].concat(args));
		}
	}, {
		key: 'defer',
		decorators: [_autobindDecorator2['default']],
		value: function defer() {
			var _this = this;

			for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
				args[_key4] = arguments[_key4];
			}

			return new _transaction2['default'](_transaction2['default'].Mode.NON_BLOCKING, function (tx) {
				var delegate = _this.run.apply(_this, args);
				delegate.observe(function (result) {
					if (result.didFail) {
						tx.reject(result.error);
					} else {
						tx.resolve(result.value);
					}
				});
			});
		}
	}, {
		key: 'run',
		decorators: [_autobindDecorator2['default']],
		value: function run() {
			var _this2 = this;

			for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
				args[_key5] = arguments[_key5];
			}

			var session = _session2['default'].Current;
			var key = this.getUniqueKey.apply(this, args);
			var cache = session ? session.queries : {};

			if (this.options.cache === false) {
				cache = {};
			}

			var execute = function execute(tx) {
				if (key in cache) {
					return tx.resolve(cache[key]);
				}

				var result = _this2.execute.apply(_this2, args);
				if (result instanceof Promise) {
					result.then(function (v) {
						cache[key] = v;
						tx.resolve(v);
					})['catch'](function (err) {
						tx.reject(err);
					});
				} else {
					cache[key] = result;
					tx.resolve(result);
				}

				return tx;
			};

			if (session) {
				return session.beginTransaction(key, execute);
			}

			return execute(new _transaction2['default']());
		}
	}]);

	return Query;
})();

exports['default'] = Query;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/query.js
// module id = jAH6
// module chunks = 15